(function () {
  var lastPct = null;

  function formatMoney(cents, symbol) {
    return symbol + (cents / 100).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,');
  }

  function updateWidget(root) {
    const thresholdCents = parseInt(root.dataset.lazThresholdCents, 10) || 0;
    let cartTotalCents = parseInt(root.dataset.lazCartTotalCents, 10) || 0;
    const symbol = root.dataset.lazCurrencySymbol || '';
    const underThresholdText = root.dataset.lazUnderThresholdText || '';
    const overThresholdText = root.dataset.lazOverThresholdText || '';

    const textEl = root.querySelector('[data-laz-free-ship-text]');
    const fillEl = root.querySelector('[data-laz-free-ship-fill]');
    const bar = root.querySelector('[role="progressbar"]');

    if (!textEl) return;

    const pct = thresholdCents <= 0 ? 100 : Math.min(100, Math.round((cartTotalCents / thresholdCents) * 100));
    const unlocked = cartTotalCents >= thresholdCents;

    if (unlocked) {
      textEl.textContent = overThresholdText;
    } else {
      const remainingCents = thresholdCents - cartTotalCents;
      textEl.textContent = underThresholdText.replace(/\{\{\s*amount\s*\}\}/g, formatMoney(remainingCents, symbol));
    }

    if (fillEl && bar) {
      var prev = lastPct != null ? lastPct : NaN;

      if (Number.isFinite(prev) && prev !== pct) {
        fillEl.style.transition = 'none';
        fillEl.style.width = prev + '%';
        fillEl.offsetHeight;
        fillEl.style.transition = '';
        fillEl.style.width = pct + '%';
      } else {
        fillEl.style.width = pct + '%';
      }

      lastPct = pct;
      bar.setAttribute('aria-valuenow', pct);
    }
  }

  function updateAll() {
    document.querySelectorAll('[data-laz-free-ship]').forEach(updateWidget);
  }

  async function onCartUpdate(event) {
    var total = event?.cartData?.total_price;
    if (total == null) {
      total = await fetch('/cart.js').then((r) => r.json()).then((data) => {
        return data?.total_price;
      }).catch((e) => { console.error('cart.js', e); });
    }
    if (total == null) return
    document.querySelectorAll('[data-laz-free-ship]').forEach(function (root) {
      root.dataset.lazCartTotalCents = String(total);
    });
    updateAll();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', updateAll);
  } else {
    updateAll();
  }

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
    subscribe(PUB_SUB_EVENTS.cartUpdate, onCartUpdate);
  }
})();
